import React, { useRef, useEffect } from 'react';
import { Carousel as NativeCarousel } from '@fancyapps/ui/src/Carousel/Carousel.js';

import '@fancyapps/ui/dist/carousel.css';

function Carousel(props) {
  const wrapper = useRef(null);

  useEffect(() => {
    const opts = props.options || {

      Dots: false, 
      infinite : true, 
      center: true, 
      fill : false,
      slidesPerPage : 1,
      friction : 0.96,
      on: {
        init: carousel => {
          carousel.$index =
            carousel.$container.querySelector('.carousel_index');
          carousel.$count =
            carousel.$container.querySelector('.carousel_count');
        },
        refresh: carousel => {
          if (carousel.$count) {
            carousel.$count.innerHTML = carousel.pages.length;
          }
        },
        change: carousel => {
          if (carousel.$index) {
            carousel.$index.innerHTML = carousel.page + 1;
          }
        },
      },
    };
    const instance = new NativeCarousel(wrapper.current, opts);

    return () => {
      instance.destroy();
    };
  });

  return (
    <div className={`carousel ${props.class || ''}`} ref={wrapper}>
      {props.children}
    </div>
  );
}

export default Carousel;
